import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { STORE_DETAILS_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { StoreDetailsComponent } from './store-details/store-details.component';

const routes: Routes = [
  {
    path: `${STORE_DETAILS_ROUTE}/:company_id/:store_id`,
    component: StoreDetailsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StoreDetailsRoutingModule {}
